import React from "react";

import "./PrintTemplate.css";
import PrintTemplateS1 from "./PrintTemplateS1";

interface Props{
    toningData:any;
}
export class PrintTemplateS1Printer extends React.PureComponent<Props> {
  render() {
    return (
      <PrintTemplateS1 toningData={this.props.toningData} />
    );
  }
}
